module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-523.f7be44a.woff2";